var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { getTestId } from '@airtel/air-design-system';
import { DynamicScrollList } from './components/dynamic-scroll-list';
export var withDynamicScrollList = Component => {
  var Wrapper = props => {
    var _props$showDynamicScr = props.showDynamicScrollList,
      showDynamicScrollList = _props$showDynamicScr === void 0 ? false : _props$showDynamicScr,
      _props$dynamicScrollL = props.dynamicScrollListProps,
      dynamicScrollListProps = _props$dynamicScrollL === void 0 ? {} : _props$dynamicScrollL,
      _props$animatedScroll = props.animatedScrollViewProps,
      animatedScrollViewProps = _props$animatedScroll === void 0 ? {} : _props$animatedScroll,
      restProps = __rest(props, ["showDynamicScrollList", "dynamicScrollListProps", "animatedScrollViewProps"]);
    var onUserAction = props.onUserAction;
    return _jsx(_Fragment, {
      children: showDynamicScrollList ? _jsx(_Fragment, {
        children: _jsx(DynamicScrollList, Object.assign({}, dynamicScrollListProps, {
          childrenToRender: Component,
          onUserAction: onUserAction,
          animatedScrollViewProps: animatedScrollViewProps
        }, getTestId(props.testID, 'withDynamicScrollList')))
      }) : _jsx(Component, Object.assign({}, restProps))
    });
  };
  return Wrapper;
};